import { faLaptopCode } from "@fortawesome/free-solid-svg-icons"
import { faFolderOpen } from "@fortawesome/free-solid-svg-icons"
import { faAward } from "@fortawesome/free-solid-svg-icons"

const Array = [
{
    title:"Experince",
    subtitle:"2+ year",
    brand:faAward
},
{
    title:"Projects",
    subtitle:"20+ projects",
    brand: faFolderOpen
},
{
    title:"Questions",
    subtitle:"400+ question",
    brand: faLaptopCode
},
];

export default Array;